export var AUTO_LEVEL={width:0,height:0,label:"Auto",bitrate:0,id:-1};